import { render } from "./AsideIGLOW.vue?vue&type=template&id=d7149594&ts=true"
import script from "./AsideIGLOW.vue?vue&type=script&lang=ts"
export * from "./AsideIGLOW.vue?vue&type=script&lang=ts"

import "./AsideIGLOW.vue?vue&type=style&index=0&id=d7149594&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__